import _ from "lodash";
import React, { useMemo, useCallback, useEffect, useState } from "react";
import update from "immutability-helper";
import { Dropdown, Checkbox } from "semantic-ui-react";

import "./MultiSelect.scss";

export const MultiSelect = ({ options, ...selectProps }: any) => {
  const [filter] = useState("");
  const [values, setValues] = useState(_.compact(_.castArray(selectProps.value)));

  const placeholder = useMemo(
    () => <span style={{ color: "#C7C7C7" }}>{selectProps.placeholder}</span>,
    [selectProps.placeholder],
  );
  const buttonContent = useMemo(
    () =>
      _.isEmpty(values)
        ? placeholder
        : _.join(
            options.filter((option: any) => values.includes(option.value)).map((option: any) => option.text),
            ", ",
          ),
    [values, placeholder, options],
  );
  const onChange = useCallback(
    (e: any, { value }: any) => {
      let newValues = [];
      if (value !== "") {
        newValues = values.includes(value)
          ? update(values, { $splice: [[values.indexOf(value), 1]] })
          : update(values, { $push: [value] });
      }
      if (selectProps.onChange) {
        selectProps.onChange(e, { value: newValues });
      }
      setValues(newValues);
    },
    [setValues, selectProps.onChange, values],
  );
  const dropdownOptions = useMemo(() => {
    return options
      .map((option: any) => Object.assign({}, option, { checked: values.includes(option.value) }))
      .filter((option: any) => option.text.toLowerCase().includes(filter))
      .map((option: any) => {
        return Object.assign({}, option, {
          content: (
            <Checkbox
              label={option.text}
              checked={option.checked}
              onMouseDown={(e) => e.preventDefault()}
              onClick={(e) => {
                onChange(e, { value: option.value });
              }}
            />
          ),
        });
      });
  }, [options, values]);

  useEffect(() => {
    setValues(_.compact(_.castArray(selectProps.value)));
  }, [selectProps.value]);

  return (
    <Dropdown
      fluid
      search
      clearable
      selection
      lazyLoad
      name={selectProps.name}
      selectOnBlur={false}
      selectOnNavigation={false}
      className='MultiSelect'
      text={buttonContent as string}
      closeOnChange={false}
      onChange={onChange}
      value={_.isEmpty(_.compact(_.castArray(selectProps.value))) ? "" : true}
      options={dropdownOptions}
    />
  );
};

export default MultiSelect;
